<ng-container *ngIf="errorsDetails$ | async as errorDetails">
  <ng-container *ngIf="!hidden">
    <p *ngFor="let error of errorDetails">
      {{
        prefix + '.' + error[0] | cxTranslate: getTranslationParams(error[1])
      }}
    </p>
  </ng-container>
</ng-container>
